<template>
    <span class="kv-amount">{{ parts.prefix }}<span v-if="parts.cents" class="kv-amount-cents">{{ parts.cents }}</span>{{ parts.suffix }}</span>
</template>

<script>
import CurrencyMixin from "@/mixins/currency-mixin";

const LOCALE_BY_LANG = {
    ptBr: 'pt-BR',
    pt: 'pt-BR',
    en: 'en-US',
    es: 'es-ES',
};

export default {
    name: "KvAmount",
    mixins: [CurrencyMixin],
    props: {
        value: {
            type: [Number, String],
            default: 0,
        },
        decimals: {
            type: Number,
            default: null,
        },
        currency: {
            type: [Boolean, String],
            default: null,
        },
        locale: {
            type: String,
            default: null,
        },
    },
    computed: {
        resolvedCurrency() {
            if (this.currency === true) return this.placeCurrency;
            return this.currency || null;
        },
        resolvedLocale() {
            if (this.locale) return this.locale;
            if (this.resolvedCurrency) return this.placeLocale || 'pt-BR';
            return LOCALE_BY_LANG[this.$root.lang] || 'pt-BR';
        },
        parts() {
            const options = {};
            if (this.resolvedCurrency) {
                options.style = 'currency';
                options.currency = this.resolvedCurrency;
            }

            const decimals = this.decimals ?? (this.resolvedCurrency ? null : 2);
            if (decimals !== null) {
                options.minimumFractionDigits = decimals;
                options.maximumFractionDigits = decimals;
            }

            const formatted = new Intl.NumberFormat(this.resolvedLocale, options)
                .formatToParts(parseFloat(this.value) || 0);

            const result = { prefix: '', cents: '', suffix: '' };
            let section = 'prefix';
            formatted.forEach((part) => {
                if (part.type === 'decimal') {
                    section = 'cents';
                } else if (section === 'cents' && part.type !== 'fraction') {
                    section = 'suffix';
                }
                result[section] += part.value;
            });
            return result;
        },
    },
};
</script>

<style lang="less" scoped>
.kv-amount {
    white-space: nowrap;
}

.kv-amount-cents {
    font-size: 0.6em;
}
</style>
